import { UseFormReturn } from 'react-hook-form';
import { AddTestForm } from 'shared/types';
import { clearCustomQueryValidation } from './customSqlCloudTest';
import TestStackSelector from './TestStackSelector';

type Props = {
  methods: UseFormReturn<AddTestForm>;
  isPrDestinationDisabled?: boolean;
};

const CustomQueryDestinationSelector = ({
  methods,
  isPrDestinationDisabled,
}: Props) => (
  <TestStackSelector
    value={methods.watch('customQueryDestination')}
    onChange={(stack) => {
      methods.setValue('customQueryDestination', stack, {
        shouldValidate: true,
      });
      clearCustomQueryValidation(methods);
      if (methods.getValues('testName')?.trim()) {
        methods.trigger('testName');
      }
    }}
    options={[
      {
        stack: 'cloud',
        label: 'Elementary Cloud',
        recommended: true,
      },
      {
        stack: 'pr',
        label: 'dbt',
        disabledReason: isPrDestinationDisabled
          ? 'Connect a code repository'
          : undefined,
      },
    ]}
  />
);

export default CustomQueryDestinationSelector;
